import { Component, OnInit, ElementRef } from '@angular/core';
import { AgentUtility } from 'app/util';
import { StringUtility } from 'app/util/string.utility';

@Component({
  selector: 'app-shop-full',
  templateUrl: './shop-full.component.html'
})
export class ShopFullComponent implements OnInit {

  constructor(private eRef: ElementRef) { }

  // должен ли отображаться виджет геймификации
  public isWidgetShown = false;

  ngOnInit() {
    this.initWidgets();
  }

  public initWidgets() {
    const isGamification = AgentUtility.getUser().IsGamification;
    this.isWidgetShown = isGamification;

    if (isGamification === true) {
      this.addWidgetToPage('shop', 'widget-shop-full', 'module');
    }
  }

  public addWidgetToPage = (name: string, container: string, type: string, width?: number, height?: number, limit?: number) => {
    const script = StringUtility.getGamificationScript(name, container, type, width, height, limit);
    if (script) {
      this.eRef.nativeElement.appendChild(script);
    }
  }

}
